import React, { useContext } from 'react';

import { FaStethoscope } from 'react-icons/fa6';
import {
  FlexCol,
  FlexGrid,
  FlexRow,
} from '../../../../../common/components/v2';
import { Resource } from '../../../../../common/constants/resource';
import { FeatureFlagsContext } from '../../../../../common/featureFlagsWrapper';
import { Aps } from '../../../../tasks/types/aps';
import { ReasonsSummary } from '../../ReasonsSummary';
import styles from '../../styles.module.scss';

export const APSSummary = ({ aps }: { aps: Aps }) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { isApsDoctorInfoEnabled } = flags;
  return (
    <FlexGrid>
      <FlexRow>
        <label className={styles.EvidenceTitle}>APS</label>
      </FlexRow>
      {!isApsDoctorInfoEnabled && (
        <>
          <FlexRow>
            <label className={styles.DrawerSubTitle}>DOCTOR'S INFO</label>
          </FlexRow>
          <FlexRow>
            <FlexCol xs={1} sm={1} lg={1}>
              <FaStethoscope />
            </FlexCol>
            <FlexCol xs={11} sm={11} lg={11}>
              <span className={styles.Info}>{aps.doctorInfo}</span>
            </FlexCol>
          </FlexRow>
        </>
      )}
      <ReasonsSummary
        title={Resource.ORDER_REASON}
        reasons={aps.reason}
        description={aps.reasonDescription}
      />
    </FlexGrid>
  );
};
